module.exports = __webpack_public_path__ + "img/29-Hyperpigmentation.8e36cfb7.png";